import HttpGlobal from "../Global/HttpGlobal.class";
import { calculatorOnGateway, nativeGatewayBaseUrl } from "../../../native/nativeMode";

export default class HttpPublicRepository extends HttpGlobal {
  private readonly API_URL_PUBLIC:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/public`;

  getValidationActuarialAge = async (date: string) => {
    // Organic native: la validación de edad la sirve el gateway desde la primera
    // pantalla del calculador (el monolito es otro origen en native.life5.it → CORS).
    if (!calculatorOnGateway()) {
      return this.generalGet(`${this.API_URL_PUBLIC}/age/validation/${date}`);
    }
    const response = await this.generalGet(
      `${nativeGatewayBaseUrl()}/organic/validate-age?birthDate=${encodeURIComponent(date)}`
    );
    // El gateway responde 200 {valid, age}; el monolito, 400 si la edad no vale.
    // Quien valida solo mira si la llamada falla: sin esto, una edad fuera de
    // rango pasaba en native.
    if (false === response?.valid) {
      throw { status: 400, error: "AGE_NOT_VALID", message: "AGE_NOT_VALID" };
    }
    return response;
  };

  validateEmail = async (email: string) => {
    // Organic native: el gateway replica el validador del monolito (sintaxis + MX)
    // y responde igual: 200 si vale, 400 si no.
    const url = calculatorOnGateway()
      ? `${nativeGatewayBaseUrl()}/organic/validate-email`
      : `${this.API_URL_PUBLIC}/email/validator`;
    const response = await this.generalPost(
      {url,
      dataRequest: { email: email },}
    );
    return response;
  }
}
